import { useState } from 'react';
import { toast } from 'react-toastify';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Stack, ThemeProvider, Typography, createTheme } from '@mui/material';
import { secondaryDark } from '@modules/theme';
import { hidePlaceholderEmail } from '@utils/shared-utils';

export function CopyToClipboardColumn({ text }: { text: string }) {
    const [show, setShow] = useState(true);

    // completely remove placeholder emails from the UI
    text = hidePlaceholderEmail(text);
    if (!text) return null;

    return (
        <ThemeProvider theme={theme}>
            <Button
                sx={{
                    ['&:hover']: {
                        display: 'block !important',
                    },
                    color: 'rgba(0, 0, 0, 0.87)',
                    display: 'flex',
                    flexDirection: 'row',
                }}
                onClick={(e) => {
                    navigator.clipboard.writeText(text);
                    e.preventDefault();
                    e.stopPropagation();
                    toast.info(`text copied: ${text}`);
                }}
                onMouseOver={() => setShow(true)}
                onMouseOut={() => setShow(false)}
            >
                <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: 'inherit', marginRight: show ? 0 : '1.5em' }}>
                        {text}
                    </Typography>
                    <ContentCopyIcon
                        fontSize="inherit"
                        sx={{
                            display: show ? 'block' : 'none',
                            marginLeft: '.5em',
                            marginTop: '.25em',
                            color: secondaryDark,
                        }}
                    />
                </Stack>
            </Button>
        </ThemeProvider>
    );
}

const theme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
    },
});
